import {createApp, nextTick, reactive} from "petite-vue";
import SearchField from "../components/search-field";
import SearchParameter from "../components/search-parameter";
import Filter from "./filter";

interface WatchdogStore {
    parameters: string
    prepareParameters(): void
}

export default function initWatchdogCreator(): void {
    const filterForm = document.querySelector('[data-offer-filter]'),
        watchdogSubmit = document.querySelector<HTMLFormElement>('[data-watchdog-create]')

    if (!filterForm || !watchdogSubmit || typeof filterData !== 'object') return

    const watchdog = reactive(Object.assign<FilterStore, WatchdogStore>(Filter(), {
        parameters: "",
        async prepareParameters() {
            const query = {...this.selectedFieldsQuery, ...this.selectedParams},
                orderedQuery = Object.keys(this.queryOrder)
                    .sort()
                    .reduce<Query>((object, key: string) => {
                        return {...object, [key]: ""}
                    }, {})

            Object.entries(query).forEach(([translatedKey, value]) => {
                const key = Object.keys(this.queryOrder)
                    .find(key => this.queryOrder[key] === translatedKey) ?? translatedKey

                if (!orderedQuery.hasOwnProperty(key)) return

                if (key !== 'radius') {
                    orderedQuery[key] = Array.isArray(value) ? value.sort().join(',') : value.toString()
                } else if (Array.isArray(value) && value.length) {
                    const radiusValues = value.sort().map((radius: string) => {
                        const valueArray = radius.split('+')
                        return {id: valueArray[0], radius: valueArray[1] ?? '0'}
                    }).filter(city => city.radius != '0')

                    if (value.length > 1) {
                        radiusValues.forEach(city => {
                            orderedQuery[`${key}[${city.id}]`] = city.radius
                        })
                    } else if (radiusValues.length) {
                        orderedQuery[key] = radiusValues[0].radius
                    }
                }
            })

            Object.entries(orderedQuery).forEach(([key, value]) => {
                (value === "" || value === "default") && delete orderedQuery[key]
            })

            this.parameters = encodeURIComponent(JSON.stringify(orderedQuery))
            await nextTick(() => {
                watchdogSubmit?.submit()
            })
        }
    }))

    createApp({ SearchField, SearchParameter, watchdog }).mount(filterForm)
    createApp({ watchdog }).mount(watchdogSubmit)
}
